import { AxiosResponse } from 'axios';

import {
  CreateUserRequestType,
  EditUserRequestType,
  FetchUsersRequestType,
} from './types';

import { CommonResponseType } from 'api';
import { GeneralResponseType } from 'common';
import { authServiceClient } from 'config';
import { CommonCharacters } from 'enums';
import { UserType } from 'state';

export const fetchUsersRequest = (params: FetchUsersRequestType) => {
  return authServiceClient.get<
    GeneralResponseType<UserType>,
    AxiosResponse<GeneralResponseType<UserType>>,
    FetchUsersRequestType
  >(`/user`, { params });
};

export const createUserRequest = (data: CreateUserRequestType) => {
  return authServiceClient.post<UserType, AxiosResponse<UserType>, CreateUserRequestType>(
    `/user`,
    data,
  );
};

export const deleteUserRequest = (id: string) => {
  return authServiceClient.delete<CommonResponseType, AxiosResponse<CommonResponseType>>(
    `/user/${id}`,
  );
};

export const editUserRequest = (user: EditUserRequestType & { id: string }) => {
  const data = {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    role: user.role,
    password:
      user.password !== CommonCharacters.HIDDEN_PASSWORD ? user.password : undefined,
    communityIds: user.communityIds ?? [],
    propertiesIds: user.propertiesIds ?? [],
  };

  return authServiceClient.put<
    CommonResponseType,
    AxiosResponse<CommonResponseType>,
    EditUserRequestType
  >(`/user/${user.id}`, data);
};

export const fetchCertainUserRequest = (id: string) => {
  return authServiceClient.get<UserType, AxiosResponse<UserType>>(`/user/${id}`);
};
